/* tslint:disable */
/* eslint-disable */
/**
 * Business Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PutOrganizationsWithAccountsRequest
 */
export interface PutOrganizationsWithAccountsRequest {
    /**
     * 組織コード
     * @type {string}
     * @memberof PutOrganizationsWithAccountsRequest
     */
    organizationCode: string;
    /**
     * グループID
     * @type {string}
     * @memberof PutOrganizationsWithAccountsRequest
     */
    companyCode?: string;
    /**
     * 会社ID
     * @type {string}
     * @memberof PutOrganizationsWithAccountsRequest
     */
    companyId?: string;
    /**
     * 営業所ID
     * @type {string}
     * @memberof PutOrganizationsWithAccountsRequest
     */
    salesOfficeId?: string;
    /**
     * アカウントIDの一覧
     * @type {Array<string>}
     * @memberof PutOrganizationsWithAccountsRequest
     */
    accountIds: Array<string>;
}

/**
 * Check if a given object implements the PutOrganizationsWithAccountsRequest interface.
 */
export function instanceOfPutOrganizationsWithAccountsRequest(value: object): value is PutOrganizationsWithAccountsRequest {
    if (!('organizationCode' in value) || value['organizationCode'] === undefined) return false;
    if (!('accountIds' in value) || value['accountIds'] === undefined) return false;
    return true;
}

export function PutOrganizationsWithAccountsRequestFromJSON(json: any): PutOrganizationsWithAccountsRequest {
    return PutOrganizationsWithAccountsRequestFromJSONTyped(json, false);
}

export function PutOrganizationsWithAccountsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PutOrganizationsWithAccountsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'organizationCode': json['organization_code'],
        'companyCode': json['company_code'] == null ? undefined : json['company_code'],
        'companyId': json['company_id'] == null ? undefined : json['company_id'],
        'salesOfficeId': json['sales_office_id'] == null ? undefined : json['sales_office_id'],
        'accountIds': json['account_ids'],
    };
}

export function PutOrganizationsWithAccountsRequestToJSON(json: any): PutOrganizationsWithAccountsRequest {
    return PutOrganizationsWithAccountsRequestToJSONTyped(json, false);
}

export function PutOrganizationsWithAccountsRequestToJSONTyped(value?: PutOrganizationsWithAccountsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'organization_code': value['organizationCode'],
        'company_code': value['companyCode'],
        'company_id': value['companyId'],
        'sales_office_id': value['salesOfficeId'],
        'account_ids': value['accountIds'],
    };
}

